import actionCreatorFactory from 'typescript-fsa';
import { Dispatch, Action } from 'redux';
import { downloadData } from 'aws-amplify/storage';
import { getAPI, putAPI, postAPI, delAPI } from '../utils/APIUtils';

import { appActions } from './appAction';
import { UsersResult, UserGroup, User, State, Catalog, Field } from '../states/settingState';
import { AdditionUser } from '../components/Setting';

const actionCreator = actionCreatorFactory();

const downloadFormLGWAN = async (path: string, idid: string) => {
  const apiurl = `/tempfile?path=private/${idid}/${path}`;
  const json = await getAPI(apiurl);
  const realdownloadurl = (process.env.REACT_APP_LGWAN_S3_REVERSE_ENDPOINT && process.env.REACT_APP_LGWAN_S3_VPC_ENDPOINT) ? json.downloadUrl.replace(process.env.REACT_APP_LGWAN_S3_VPC_ENDPOINT, process.env.REACT_APP_LGWAN_S3_REVERSE_ENDPOINT) : json.downloadUrl;

  const file = await fetch(realdownloadurl);
  const blob = await file.blob();

  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  const filename = path.split('/').pop();
  link.setAttribute('download', filename ? filename : 'noname');
  document.body.appendChild(link);
  link.click();
};

const downloadForm = async (path: string, idid: string) => {
  const downloadTask = await downloadData({
    path: `private/${idid}/${path}`,
  });
  const { body } = await downloadTask.result;
  const blob = new Blob([await body.blob()]);
  const url = window.URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = url;
  const filename = path.split('/').pop();
  link.setAttribute('download', filename ? filename : 'noname');
  document.body.appendChild(link);
  link.click();
};

const getMaxCatalogId = (cs: Catalog[]): number => {
  let maxCatalogId = -1;
  for (const catalog of cs) {
    if (catalog.id === '9999') continue;
    const nid = Number(catalog.id);
    maxCatalogId = nid > maxCatalogId ? nid : maxCatalogId;
    if (catalog.child) {
      getMaxCatalogId(catalog.child);
    }
  }
  return maxCatalogId;
};

const getMaxFieldId = (fs: Field[]): number => {
  let maxCatalogId = -1;
  for (const filed of fs) {
    if (filed.id === '9999') continue;
    const nid = Number(filed.id);
    maxCatalogId = nid > maxCatalogId ? nid : maxCatalogId;
  }
  return maxCatalogId;
};

export const settingAction = {
  getUser: actionCreator<UsersResult>('ACTIONS_GET_USER'),
  getUserGroups: actionCreator<UserGroup[]>('ACTIONS_GET_USERGROUPS'),
  setCompleteUsersAddtion: actionCreator<boolean>('ACTIONS_SET_COMPLETE_USERS_ADDTION'),
  getUserAsync: (accountId: string, idid: string, role: string, start: number, size: number) => {
    return async (dispatch: Dispatch<Action>) => {
      try {
        const url = `/users?accountid=${accountId}&role=${role}&start=${start}&size=${size}`;
        const json = await getAPI(url);
        dispatch(settingAction.getUser(json));

        {
          const url2 = `/usergroups?accountid=${accountId}&idid=${idid}`;
          const json2 = await getAPI(url2);
          dispatch(settingAction.getUserGroups(json2.userGroups));
        };

      } catch (err) {
        console.log(err);
      }
      dispatch(appActions.setLoading(false));
    };
  },
  putUserAsync: (accountId: string, role: string, start: number, size: number, item: User, id: string) => {
    return async (dispatch: Dispatch<Action>) => {
      try {
        const url = `/users/${item.userId}`;
        const options = {
          accountId: accountId,
          id: id,
          name: item.name,
          role: item.role,
          userGroupId: item.userGroupId,
          enabled: item.enabled,
        };
        await putAPI(url, options);

        // 再取得
        const url2 = `/users?accountid=${accountId}&role=${role}&start=${start}&size=${size}`;
        const json = await getAPI(url2);
        dispatch(settingAction.getUser(json));

      } catch (err) {
        console.log(err);
      };
      dispatch(appActions.setLoading(false));
    };
  },
  postUsersAsync: (accountId: string, idid: string, role: string, start: number, size: number, id: string, postUsers: AdditionUser[]) => {
    return async (dispatch: Dispatch<Action>) => {
      try {
        const url = `/users`;
        const options = {
          accountId: accountId,
          idid: idid,
          id: id,
          postUsers: JSON.parse(JSON.stringify(postUsers)),
        };
        const json = await postAPI(url, options);

        // 再取得
        {
          const url2 = `/users?accountid=${accountId}&role=${role}&start=${start}&size=${size}`;
          const json2 = await getAPI(url2);
          dispatch(settingAction.getUser(json2));
        };

        const newOutPath = json.outPath.replace(/private\/.*?\//, '');
        if (process.env.REACT_APP_LGWAN && process.env.REACT_APP_LGWAN === 'LG-WAN') {
          downloadFormLGWAN(newOutPath, idid);
        } else {
          downloadForm(newOutPath, idid);
        }
        dispatch(settingAction.setCompleteUsersAddtion(true));

      } catch (err) {
        console.log(err);
      };
      dispatch(appActions.setLoading(false));
    };
  },
  setCompleteActTypeAddtion: actionCreator<boolean>('ACTIONS_SET_COMPLETE_ACTTYPE_ADDTION'),
  postActTypeAsync: (accountId: string, idid: string, id: string, fileName: string) => {
    return async (dispatch: Dispatch<Action>) => {
      try {
        const url = `/acttype`;
        const options = {
          accountId: accountId,
          idid: idid,
          id: id,
          fileName: fileName,
        };
        const json = await postAPI(url, options);

        const newOutPath = json.outPath.replace(/private\/.*?\//, '');
        if (process.env.REACT_APP_LGWAN && process.env.REACT_APP_LGWAN === 'LG-WAN') {
          downloadFormLGWAN(newOutPath, idid);
        } else {
          downloadForm(newOutPath, idid);
        }

        dispatch(settingAction.setCompleteActTypeAddtion(true));

      } catch (err) {
        console.log(err);
      };
      dispatch(appActions.setLoading(false));
    };
  },
  postUserGroupsAsync: (accountId: string, idid: string, id: string, fileName: string) => {
    return async (dispatch: Dispatch<Action>) => {
      try {
        const url = `/usergroups`;
        const options = {
          accountId: accountId,
          idid: idid,
          id: id,
          fileName: fileName,
        };
        await postAPI(url, options);

        dispatch(settingAction.getUserGroupsState({ state: 'Processing' }));

      } catch (err) {
        console.log(err);
      };
      dispatch(appActions.setLoading(false));
    };
  },
  getUserGroupsState: actionCreator<State>('ACTIONS_GET_USERGROUPS_STATE'),
  getUserGroupsStateAsync: (accountId: string, idid: string) => {
    return async (dispatch: Dispatch<Action>) => {
      try {
        const url = `/usergroups/state?accountid=${accountId}&idid=${idid}`;
        const json = await getAPI(url);

        dispatch(settingAction.getUserGroupsState(json));

      } catch (err) {
        console.log(err);
      }
      dispatch(appActions.setLoading(false));
    };
  },
  postCatalogAsync: (accountId: string, idid: string, id: string, fileName: string) => {
    return async (dispatch: Dispatch<Action>) => {
      try {
        const url = `/catalog`;
        const options = {
          accountId: accountId,
          idid: idid,
          id: id,
          fileName: fileName,
        };
        await postAPI(url, options);

        dispatch(settingAction.getCatalogState({ state: 'Processing' }));

      } catch (err) {
        console.log(err);
      };
      dispatch(appActions.setLoading(false));
    };
  },
  getCatalogState: actionCreator<State>('ACTIONS_GET_CATALOG_STATE'),
  getCatalogStateAsync: (accountId: string, idid: string) => {
    return async (dispatch: Dispatch<Action>) => {
      try {
        const url = `/catalog/state?accountid=${accountId}&idid=${idid}`;
        const json = await getAPI(url);

        dispatch(settingAction.getCatalogState(json));

      } catch (err) {
        console.log(err);
      }
      dispatch(appActions.setLoading(false));
    };
  },
  getCatalog: actionCreator<Catalog[]>('ACTIONS_GET_CATALOG'),
  setMaxCatalogId: actionCreator<number>('ACTIONS_SET_MAX_CATALOGID'),
  getCatalogAsync: (accountid: string, idid: string) => {
    return async (dispatch: Dispatch<Action>) => {
      try {
        const url = `/catalog?accountid=${accountid}&idid=${idid}`;
        const json = await getAPI(url);
        dispatch(settingAction.getCatalog(json.result));

        const maxcid = getMaxCatalogId(json.result);
        dispatch(settingAction.setMaxCatalogId(maxcid));

      } catch (err) {
        console.log(err);
      };
      dispatch(appActions.setLoading(false));
    };
  },
  postFieldAsync: (accountId: string, idid: string, id: string, fileName: string) => {
    return async (dispatch: Dispatch<Action>) => {
      try {
        const url = `/field`;
        const options = {
          accountId: accountId,
          idid: idid,
          id: id,
          fileName: fileName,
        };
        await postAPI(url, options);

        dispatch(settingAction.getFieldState({ state: 'Processing' }));

      } catch (err) {
        console.log(err);
      };
      dispatch(appActions.setLoading(false));
    };
  },
  getFieldState: actionCreator<State>('ACTIONS_GET_FIELD_STATE'),
  getFieldStateAsync: (accountId: string, idid: string) => {
    return async (dispatch: Dispatch<Action>) => {
      try {
        const url = `/field/state?accountid=${accountId}&idid=${idid}`;
        const json = await getAPI(url);

        dispatch(settingAction.getFieldState(json));

      } catch (err) {
        console.log(err);
      }
      dispatch(appActions.setLoading(false));
    };
  },
  getField: actionCreator<Catalog[]>('ACTIONS_GET_FIELD'),
  setMaxFieldId: actionCreator<number>('ACTIONS_SET_MAX_FIELDID'),
  getFieldAsync: (accountid: string, idid: string) => {
    return async (dispatch: Dispatch<Action>) => {
      try {
        const url = `/field?accountid=${accountid}&idid=${idid}`;
        const json = await getAPI(url);
        dispatch(settingAction.getField(json.result));

        const maxcid = getMaxFieldId(json.result);
        dispatch(settingAction.setMaxFieldId(maxcid));

      } catch (err) {
        console.log(err);
      };
      dispatch(appActions.setLoading(false));
    };
  },
  deleteUserAsync: (accountId: string, start: number, size: number, id: string, userId: string) => {
    return async (dispatch: Dispatch<Action>) => {
      try {
        const url = `/users/${userId}?id=${id}`;
        await delAPI(url);

        // 再取得
        const url2 = `/users?accountid=${accountId}&start=${start}&size=${size}`;
        const json = await getAPI(url2);
        dispatch(settingAction.getUser(json));

      } catch (err) {
        console.log(err);
      };
      dispatch(appActions.setLoading(false));
    };
  },
};
